import React, { useEffect } from "react";

interface Props {
  barcodeRef: React.RefObject<HTMLInputElement>;
}

export const BarcodeInputField = ({ barcodeRef }: Props) => {
  const [interval, setRefocusInterval] = React.useState<
    number | NodeJS.Timeout
  >(1);

  useEffect(() => {
    const refocus = () => {
      barcodeRef.current?.focus();
      setTimeout(() => {
        barcodeRef.current?.focus();
      }, 0);
    };
    const barcodeReference = barcodeRef.current;
    barcodeReference?.addEventListener("blur", refocus);
    barcodeReference?.focus();
    clearInterval(interval);
    const temp = setInterval(() => {
      barcodeReference?.focus();
    }, 3000);
    setRefocusInterval(temp);
    return () => {
      clearInterval(interval);
      barcodeReference?.removeEventListener("blur", refocus);
    };
  }, [barcodeRef]);
  return (
    <label htmlFor="barcode">
      Please Scan a Barcode
      <br />
      <input
        autoFocus
        onBlur={({ target }) => target.focus()}
        ref={barcodeRef}
      />
    </label>
  );
};
